import z from 'zod';

export const WorkstationSchema = z.object({
    id: z.string(),
    name: z.string(),
    allowMultipleInProgress: z.boolean(),
});

export type Workstation = z.infer<typeof WorkstationSchema>;
